module.exports = __webpack_public_path__ + "static/media/success.41934d1b.svg";